import React from "react";
import { AiFillGithub, AiFillLinkedin, AiFillInstagram } from 'react-icons/ai';
import { Container, Div1, Div2, Div3, NavLinksContainer, NavLink, SocialIcons } from "./NavBarStyles";
import { Link } from "react-scroll";

const Test = () => (
    <div style={{  }}>
        <Container style={{  }}>

            <Div1 style={{  }}>
                <span style={{  }}>My Portfolio</span>
            </Div1>

            <Div2 style={{  }}>
                <NavLinksContainer>
                    <Link to="about" smooth={true} duration={1000}>
                        <NavLink style={{}}>About</NavLink>
                    </Link>
                    <Link to="work" smooth={true} duration={1000}>
                        <NavLink>Work</NavLink>
                    </Link>
                    <Link to="projects" smooth={true} duration={1000}>
                        <NavLink>Projects</NavLink>
                    </Link>
                    <Link to="volunteer" smooth={true} duration={1000}>
                        <NavLink>Volunteer</NavLink>
                    </Link>
                    <Link to="contact" smooth={true} duration={1000}>
                        <NavLink>Contact</NavLink>
                    </Link>
                </NavLinksContainer>
            </Div2>

            <Div3 style={{  }}>
                <SocialIcons href="https://github.com/kanavjain08">
                    <AiFillGithub size="2.5rem" />
                </SocialIcons>
                <SocialIcons href="https://www.linkedin.com/in/kanavjain25/">
                    <AiFillLinkedin size="2.5rem" />
                </SocialIcons>
                <SocialIcons href="https://www.instagram.com/kanav_25/">
                    <AiFillInstagram size="2.5rem" />
                </SocialIcons>
            </Div3>

        </Container>
    </div>
);

export default Test;
